'use es6';

import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import { parseQueryString } from './qs';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
export const getLocaleFromUrl = () => {
  const {
    languagePreference
  } = parseQueryString(window.location.search);
  return languagePreference ? decodeURIComponent(languagePreference) : '';
};
export const loadI18n = (locale = getLocaleFromUrl() || null) => {
  let publicI18nProvider;
  if (locale) {
    publicI18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    publicI18nProvider.setLocale({
      langEnabled: true,
      locale
    });
  } else {
    publicI18nProvider = createPublicI18nProvider();
  }
  return publicI18nProvider.register(lang);
};